export default __webpack_public_path__ + "static/zhamak-tanmai-talk-fc4f99eb2aa70cd2689218515fcb4ac9.png";